import { useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { Button, Modal, ModalBody } from "reactstrap";
import helpIcon from "../../assets/help-icon.png";
import { useTranslation } from "../../languages";

const InfoModal2 = ({ text, title }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <Button
        onClick={() => setModalOpen(true)}
        className="text-decoration-none bg-transparent border-none p-0"
      >
        <img
          src={helpIcon}
          height={40}
          width={40}
          className="object-fit-contain"
          alt="help"
        />
      </Button>
      <Modal
        fade={false}
        centered
        isOpen={modalOpen}
        toggle={() => setModalOpen((prev) => !prev)}
      >
        <ModalBody
          style={{ borderRadius: "30px" }}
          className="bg-white px-lg-4 py-3"
        >
          <h5 className="m-0 text-center mb-3 figma-shadowed-black-text ">
            {title || t("info")}
          </h5>

          <div
            className="p-3 f-5 text-center"
            style={{ minHeight: "300px", lineHeight: "31.69px" }}
          >
            {text}
          </div>
          <div className="d-flex justify-content-center">
            <Button
              className="standard-rounded-btn full-width"
              onClick={() => setModalOpen(false)}
            >
              {t("done")}
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default InfoModal2;
